import BaseService from './BaseService';
import { camelizeKeys } from 'humps';
import normalize from 'jsonapi-normalizer';
import dates from '@/utils/dates';

const objectType = 'larval-identifications';

class LarvalIdentificationService extends BaseService {

  static getList(page) {

    return super.get(`larval_identifications?filter=id_date=null&page[number]=${page}&page[size]=${this.pageSize()}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static search(search, page) {

    return super.get(`larval_identifications/search?search[field]=${search.field}&search[term]=${search.term}&page[number]=${page}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static getDetails(id) {
    return super.get(`larval_identifications/${id}`)
      .then((response) => {
        let object = normalize(response.data);
        let data = object.entities[objectType][object.result[objectType][0]];
        data = camelizeKeys(data);

        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static create(data) {

    data = dates.apiFormat(data, ['idDate']);

    return super.post(objectType, `larval_identifications`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {

    data = dates.apiFormat(data, ['idDate']);

    return super.patch(objectType, `larval_identifications/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`larval_identifications/${id}`)
      .then((response) => {
        return Promise.resolve({id});
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

}

export default LarvalIdentificationService;